/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {QuantityInput} from "../forms/QuantityInput";
import {AddToCartButton} from "../bootstrap/Button";

export const OptionalBundleCartCell = ({bundle, setQuantity, quantity, remainingQuantity, isBundleLoading, orderProduct, response, translate, color}) => {
    return <div className={"p-bundle-row__cell p-bundle-row__cell--selector"}>
        <div>
            <p>{translate("Total price")}</p>
            <p className={bundle.promotionUnitPriceDouble > 0 ? "text-lt" : ""}>{bundle.unitPrice}</p>
            {bundle.promotionUnitPriceDouble > 0 &&
            <p className={"promoted-value"}>{bundle.promotionUnitPrice}</p>}
        </div>
        <div className={"p-flex p-flex-align-center p-flex-justify-content-end"}>
            <QuantityInput updateValue={setQuantity} value={quantity} max={remainingQuantity} min={1}
                           disabled={isBundleLoading || remainingQuantity === 0}/>
            <AddToCartButton small className={"btn-block btn-sm p-margin-top-sm"} loading={isBundleLoading}
                             disabled={!remainingQuantity || isBundleLoading} block onClick={orderProduct}
                             response={response} noRemainingQuantity={!remainingQuantity}
                             translate={translate} color={color}/>
        </div>
    </div>
};
